import { ChartSettingsT } from 'business/definitions';

export const getDecimalPrecision = (settings: ChartSettingsT): 0 | 1 | 2 => {
    const { decimalPrecision } = settings;
    if (decimalPrecision === undefined) {
        return 2;
    }
    return decimalPrecision;
};
